import _ from "lodash";
import {
  ACCOUNT_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
  BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
  BEHAVIOUR_MANAGEMENT_TOGGLE_MODULES_PERMISSION,
  BEHAVIOUR_RNP_MODULE_SETTINGS,
  PROGRAMME_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
} from "Constants/permissionConstants";
import ACLStorage from "lib/aclService";
import { getIsBehaviourRnPModuleConsumptionEnabled } from "Utils/ACLStoreUtils";

export const getIsBehaviourModuleEnabledInModuleSettingsAndRnP = curriculumProgramId => {
  const context = [
    {
      entityId: curriculumProgramId,
      entityType: "CURRICULUM_PROGRAM",
    },
  ];

  // check if behaviour management toggle is enabled in module settings
  const isEnabledInModuleSettings = ACLStorage.getModuleSettingsValueByContext(
    BEHAVIOUR_MANAGEMENT_TOGGLE_MODULES_PERMISSION,
    context
  );

  if (!isEnabledInModuleSettings) {
    return false;
  }

  // check if behaviour management toggle is enabled in RnP either at account level or programme level
  return _.some(BEHAVIOUR_RNP_MODULE_SETTINGS, config =>
    ACLStorage.getModuleSettingsValueByContext(config, context)
  );
};

export const getCanAccessBehaviourDashboardInRnPOrg = ({
  curriculumProgramId,
}) => {
  const isBehaviourRnPModuleConsumptionEnabled = getIsBehaviourRnPModuleConsumptionEnabled();
  if (isBehaviourRnPModuleConsumptionEnabled) {
    const isBehaviourModuleEnabledInModuleSettingsAndRnP = getIsBehaviourModuleEnabledInModuleSettingsAndRnP(
      curriculumProgramId
    );

    return (
      isBehaviourModuleEnabledInModuleSettingsAndRnP &&
      (ACLStorage.getPermissionValue(
        ACCOUNT_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION
      ) ||
        ACLStorage.getPermissionValueByContext(
          PROGRAMME_LEVEL_BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
          [
            {
              entityId: curriculumProgramId,
              entityType: "CURRICULUM_PROGRAM",
            },
          ]
        ))
    );
  }

  return ACLStorage.getModuleSettingsValueByContext(
    BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
    [{ entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" }]
  );
};
